































import { defineComponent, ref, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import SignaturePadWrapper from "./SignaturePadWrapper";
import { SignaturePadWrapperMethods } from "./SignaturePadWrapper/types";

const MIN_SIGN_SIZE = 10000;
const DEBOUNCE_CHANGE_SIGN_DELAY = 200;

export default defineComponent({
  name: "ConsentSignForm",
  components: { BaseCheckbox, BaseIcon, BaseButton, SignaturePadWrapper },
  setup(_, { emit }) {
    const signaturePad = ref<SignaturePadWrapperMethods | null>(null);
    const sign = ref<Blob | null>(null);
    const sensitiveAgreement = ref(false);
    const acknowledgeAgreement = ref(false);

    const onClearClick = async () => {
      signaturePad.value?.clearSignature();
      sign.value = null;
    };

    const onSignChange = debounce(async () => {
      const base64String = signaturePad.value?.saveSignature().data;
      if (!base64String) return;
      const blob = new Blob([base64String]);

      if (blob.size >= MIN_SIGN_SIZE) {
        sign.value = blob;
      }
    }, DEBOUNCE_CHANGE_SIGN_DELAY);

    const checkValid = () => {
      emit("setValid", !!sign.value && sensitiveAgreement.value && acknowledgeAgreement.value);
    };

    watch([sign, sensitiveAgreement, acknowledgeAgreement], () => {
      checkValid();
    });

    return { signaturePad, sign, sensitiveAgreement, acknowledgeAgreement, onClearClick, onSignChange };
  },
});
